
import {
  Row,
  Col,
  Button,
}from 'react-bootstrap';

import {
  Label,
  Audio,
  ListView,
}from '../';

import { COLOR } from '../../const';

var React = require('react');
var Radium = require('radium');
var FontAwesome = require('react-fontawesome');

class PresentationAct extends React.Component {
  render() {
    return(
      <div>
        <Row>
          <ListView {...this.props}>
            {this.props.progressList.map(item => (
              <PresItem
                key={item.word}
                item = {item}
                isCorrect = {item.isCorrect}
                {...this.props}
              />
            ))}
          </ListView>
        </Row>
      </div>
    )
  }
}

class PresItem extends React.Component {

  playAudio = () => {
    this.audio.onPlay();
  }

  onEndedCallback = () => {
    this.props.updateProgressList({
      word: this.props.item.word,
      isCorrect: true,
      wasChecked: true,
    });
  }

  render() {

    const {container, header, sentence, footer, button, check} = styles.item.base;
    const {container: containerCorr , sentence: sentenceCorr} = styles.item.correct;
    const {container: containerNorm , sentence: sentenceNorm} = styles.item.notChecked;

    const {item, mode, toggleAudio, isAudioPlaying, isCorrect, setAudioFalse} = this.props;

    return (
      <Col
        xs={12}
        md={4}
        style={
          styles.item.base
        }
      >
        <div style={[container, isCorrect && containerCorr, !isCorrect && containerNorm]}>
          <div style={header}>
            <Label color="white" italic text={"Word"}/>
            <WordText word={item.word} />
          </div>
          <div style={[sentence, isCorrect && sentenceCorr, !isCorrect && sentenceNorm]}>
            <Label color={(isCorrect) ? "green" : "blue"} italic text={"Sentence"} />
            <SentenceText sentence={item.sentence} isCorrect={isCorrect}/>
          </div>
          <div style={footer}>
            <Button
              bsStyle="success"
              bsSize="lg"
              onClick={this.playAudio}
              style={button}
               >
              <FontAwesome
                name="volume-up"
                inverse={true}
                size="lg"
              />
            </Button>
            {isCorrect &&
              <FontAwesome
                name="check"
                inverse={true}
                size="3x"
                style={check}
              />
            }
          </div>
          <Audio
            mode={mode}
            item={item}
            onEndedCallback={(!isCorrect) ? this.onEndedCallback : null}
            isAudioPlaying={isAudioPlaying}
            toggleAudio={toggleAudio}
            setAudioFalse={setAudioFalse}
            ref={(Audio) => {this.audio = Audio;}}
          />
        </div>
      </Col>
      )
  }
}



let WordText = ({word = "word"}) => {

  return(
    <div style={styles.item.base.word}>{word}</div>
  )
}

let SentenceText = ({sentence = "sentence", isCorrect = false}) => {

  const sentenceBs = styles.item.base.sentence.text;
  const sentenceCorr = styles.item.correct.sentence.text;
  const sentenceNorm = styles.item.notChecked.sentence.text;

  return(
    <div style={[sentenceBs, isCorrect && sentenceCorr, !isCorrect && sentenceNorm]}>{sentence}</div>
  )
}

PresItem = Radium(PresItem);
WordText = Radium(WordText);
SentenceText = Radium(SentenceText);

const styles = {
  item: {
    base:{
      textAlign: 'center',
      marginBottom: '4rem',

      container: {
        borderRadius: '10px',
        minHeight: '350px',
      },
      header: {
        padding: '2rem',
      },
      sentence: {
        backgroundColor: COLOR.white,
        padding: '2rem 1rem',
        minHeight: '150px',

        text: {
          fontSize: '21px',
          fontWeight: '300',
        },
      },
      word: {
        color: COLOR.white,
        fontSize: '30px',
      },
      footer: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: '2rem',
      },
      button:{
        minWidth: '125px',
      },
      check: {
        minWidth: '150px',
      }
    },
    notChecked: {
      container: {
        borderColor: COLOR.blue,
        backgroundColor: COLOR.blue,
      },
      sentence: {
        borderLeft: `1px solid ${COLOR.blue}`,
        borderRight: `1px solid ${COLOR.blue}`,
        text: {
          color: COLOR.blue,
        },
      }
    },
    correct: {
      container: {
        borderColor: COLOR.green,
        backgroundColor: COLOR.green,
      },
      sentence: {
        borderLeft: `1px solid ${COLOR.green}`,
        borderRight: `1px solid ${COLOR.green}`,
        text: {
          color: COLOR.green,
        },
      }
    }
  },

}

export default Radium(PresentationAct);



// WEBPACK FOOTER //
// ./src/comp/Activities/PresentationAct.js